module.exports = __webpack_public_path__ + "img/product-4.cc1c8386.png";